import { ref, onMounted, onBeforeUnmount, computed } from 'vue'

/**
 * Tracks viewport width and exposes the named breakpoints used by
 * the design system. Mirrors the breakpoint maths in layout.css.
 */
const LAPTOP_MIN = 1025
const LAPTOP_MAX = 1512

export function useBreakpoint() {
  const width = ref(typeof window === 'undefined' ? 1920 : window.innerWidth)

  const onResize = () => {
    width.value = window.innerWidth
  }

  onMounted(() => window.addEventListener('resize', onResize))
  onBeforeUnmount(() => window.removeEventListener('resize', onResize))

  return {
    width,
    isMobile: computed(() => width.value <= 1024),
    isLaptop: computed(() => width.value >= LAPTOP_MIN && width.value <= LAPTOP_MAX),
    isDesktop: computed(() => width.value > LAPTOP_MAX),
    isWide: computed(() => width.value > 1700),
  }
}
